import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    refreshToken().finally(() => setLoading(false));
  }, []);

  const register = async (userData) => {
  try {
    const res = await axios.post(
      'https://www.fancyplus.digital/api/users/register',
      userData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};


  const login = async (correo, password) => {
    try {
      const res = await axios.post(
        'https://www.fancyplus.digital/api/users/login',
        { correo, password },
        { withCredentials: true }
      );

      setToken(res.data.token);
      setUser(res.data.user);
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  const loginWithGoogle = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);

      const res = await axios.post(
        'https://www.fancyplus.digital/api/users/google-login',
        { token: credentialResponse.credential }, // o lo que estés enviando
        { withCredentials: true }
      );

      setToken(res.data.token);
      setUser(res.data.user);
      return res.data;
    } catch (error) {
      throw error;
    }
  };


  const refreshToken = async () => {
    try {
      const res = await axios.post(
        'https://www.fancyplus.digital/api/users/refresh',
        null,
        { withCredentials: true }
      );

      setToken(res.data.accessToken);
      setUser(res.data.user || null);
    } catch (err) {
      console.error('No se pudo renovar el token:', err.message);
      setToken(null);
      setUser(null);
    }
  };

  const logout = async () => {
    try {
      await axios.post(
        'https://www.fancyplus.digital/api/users/logout',
        null,
        { withCredentials: true }
      );
    } catch (err) {
      console.error('Error al cerrar sesión:', err.message);
    }

    setUser(null);
    setToken(null);
  };

  // Dentro de AuthProvider (antes del return):
  const updateUser = (newUserData) => {
    setUser(prev => ({ ...prev, ...newUserData }));
  };

  return (
    <AuthContext.Provider
      value={{ user, token, register, login,loginWithGoogle, refreshToken, logout, loading, updateUser, }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
